<script>
    import { onMount } from 'svelte';
    import TableList from './TableList.svelte';
    import { auth } from '../js/auth.js';

    let extraParms = ''; 
    let tableData = {
        details: { 
            titleList: 'Your orders',
            titleEdit: 'Order detail',
            create: false,
            delete: false,
            edit: false,
            hasMediaFile: false,
            mediaFileType: 'image/*',            
            sortby: 'id',
        },
        fields: [
            { 
                key: 'id', 
                label: 'Order#', 
                type: 'text',
                editable: false, 
                sortable: true 
            },
            { 
                key: 'submitted_date', 
                label: 'Date', 
                type: 'text',
                editable: false, 
                sortable: true 
            },
            { 
                key: 'total_inc_tax', 
                label: 'Total Price', 
                type: 'text',
                editable: false, 
                sortable: true 
            },
            { 
                key: 'tax_total', 
                label: 'Tax', 
                type: 'text',
                editable: false, 
                sortable: true 
            },
            { 
                key: 'total_item_quantity', 
                label: 'Items Purchased', 
                type: 'text',
                editable: false, 
                sortable: true 
            }
        ]
    };

    $: if ($auth.user) {
        extraParms = '&user_uuid=' + $auth.user.uuid;
    }
</script>

<TableList modelName="order" {tableData} {extraParms}/>